import { Directive, HostListener, Input, ViewChild } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { environment } from '@env/environment';

@Directive({
  selector: '[appScrollOnPageChange]',
})
export class ScrollOnPageChangeDirective {
  @Input()
  anchor: string;

  @Input()
  eventName: string;

  constructor(private viewportScrollerService: ViewportScroller) {}

  @HostListener('page', ['$event'])
  @HostListener('pageEmitter', ['$event'])
  clickEvent(event: Event) {
    this.viewportScrollerService.setOffset([0, environment.offset]);
    this.viewportScrollerService.scrollToAnchor(this.anchor);

    // Internet explorer ignore viewport and as such, it scroll to anchor, not only vertically but horizontally too.
    // This result in a large horizontal offset if the anchor isn't positioned to the utmost left of the screen
    // This scroll back to the left of the screen in case it did happen
    this.viewportScrollerService.scrollToPosition([
      0,
      this.viewportScrollerService.getScrollPosition()[1],
    ]);
  }
}
